export default "__VITE_ASSET__f_Tl4kSC__"